import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { Spin } from 'antd';
import { loadMostWidespreadTag } from '../../redux/actions/widgets';
import styles from './most-widespread-tag.module.sass';
import { STATUS } from '../../redux/constants';
import Tag from '../../shared-components/Tag';
import { formatThousands } from '../../redux/utils';

export const MostWidespreadTag = (props) => {
  const { tag, status } = props;
  useEffect(() => {
    props.loadMostWidespreadTag();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const isLoading = status === STATUS.LOADING;

  return (
    <div className={styles.container}>
      {isLoading && <Spin />}
      {!isLoading && tag && (
        <div className={styles.body}>
          <Tag tag={tag} canClick={false} canRemove={false} />
          <div className={styles.threats_count}>
            {formatThousands(tag.marked_count)}
          </div>
          <div className={styles.threats}>&nbsp; Threats</div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  tag: state.widgets.mostWidespreadTag,
  status: state.widgets.mostWidespreadTagStatus,
});

const mapDispatchToProps = {
  loadMostWidespreadTag,
};

MostWidespreadTag.propTypes = {
  loadMostWidespreadTag: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  tag: PropTypes.object,
};

MostWidespreadTag.defaultProps = {
  tag: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(MostWidespreadTag);
